export const getPricePerOptimizer = (billingPlanPrice, credits) => {
    const pricePerOptimizer = billingPlanPrice / credits;
    const roundedPricePerOptimizer = Math.round(pricePerOptimizer * 100) / 100;

    return roundedPricePerOptimizer;
};
